export default __webpack_public_path__ + "static/media/p2023-13.a0f9015e.jpeg";